import React from 'react'
import CourseHomeStore from '../stores/course-home-store'
import { Box, Divider, Modal } from '@material-ui/core'
import { accent, lightAccent } from '../../../../styles/colors'
import { H4, S05 } from '../../../../styles/typography'
import { RegModal } from '../elements/registrationModal'
import getCurrencySymbol from '../../../../utils/currency-symbol'
import { useMemo } from 'react'
import computeFee from '../../../../utils/fee'
import Button from '../../../../components/button'
import { useState } from 'react'

const RegistrationModal = () => {
  const {
    RegisterModal,
    registration = {},
    setRegisterModal,
    data: {
      type,
      fee,
      currency,
      discount,
      classCount,
      name,
      teacher: { name: teacherName = 'artist' } = {},
    },
    certification: { certificationFeePremium = 50 } = {},
    register,
    registerCertification,
  } = CourseHomeStore.useContainer()
  const handleClose = () => setRegisterModal(false)
  const style = {
    width: '100%',
    boxShadow: 24,
    p: 2,
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    zIndex: 2,
  }
  const { original, isDiscounted, final, discountPercentage } = useMemo(
    () => computeFee(type === 'recorded' ? fee : fee / classCount, discount),
    [type, fee, classCount, discount],
  )
  const currencySymbol = useMemo(() => getCurrencySymbol(currency), [currency])

  const [showmore1, setshowmore1] = useState(false)
  const [showmore2, setShowmore2] = useState(false)
  const [loading, setLoading] = useState(false)
  return (
    RegisterModal && (
      <Modal
        open={RegisterModal}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        style={{
          backdropFilter: 'blur( 20px )',
        }}
      >
        <Box
          sx={style}
          onClick={(e) => {
            handleClose()
          }}
        >
          <div
            style={{
              width: '100%',
              maxHeight: '100%',
              height: 'fit-content',
              overflow: 'scroll',
              borderRadius: '5px',
              padding: '10px',
              background: 'rgba( 6, 6, 6, 0.75 )',
              boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
              backdropFilter: 'blur( 4px )',
              borderRadius: '10px',
              border: '1px solid rgba( 255, 255, 255, 0.18 )',
              transition: 'all 0.3s ease',
              zIndex: 3,
            }}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <RegModal
              hideFee={
                discount === 100 ||
                fee === 0 ||
                registration.isTeacher ||
                (registration.status === 'APPROVED' &&
                  registration.billStatus === 'PAID')
              }
            >
              <div>
                <h2
                  style={{
                    fontWeight: 900,
                    color: accent,
                    textAlign: 'center',
                  }}
                  className='RegModalHeading'
                >
                  {name}
                </h2>
                <p
                  style={{
                    color: lightAccent,
                    textAlign: 'center',
                  }}
                >
                  Pick a type of registration
                </p>
              </div>
              <div
                style={{ backgroundColor: 'white' }}
                className='PaymentType'
                onClick={() => {
                  setshowmore1(!showmore1)
                }}
              >
                <div className='PaymentHeading'>
                  <H4>Certification</H4>
                  <span className='fee'>
                    {isDiscounted && (
                      <S05>
                        {currencySymbol}{' '}
                        {(
                          original *
                          (1 + certificationFeePremium / 100)
                        ).toFixed(2)}
                      </S05>
                    )}
                    <H4>
                      {type !== 'recorded' ? (
                        <span>/ class</span>
                      ) : isDiscounted ? (
                        <span>({discountPercentage} off)</span>
                      ) : null}
                      {currencySymbol}{' '}
                      {(final * (1 + certificationFeePremium / 100)).toFixed(2)}
                    </H4>
                  </span>
                </div>
                <Divider
                  style={{
                    backgroundColor: 'black',
                    marginTop: '5px',
                    marginBottom: '5px',
                  }}
                />
                <div style={{ paddingLeft: '5px' }}>
                  {!showmore1 ? (
                    <p>
                      Certification course ensures{' '}
                      <span
                        onClick={() => {
                          setshowmore1(true)
                        }}
                      >
                        {' '}
                        Show more
                      </span>
                    </p>
                  ) : (
                    <>
                      <p>
                        Certification course ensures that along with the doing
                        the course at your own pace, you also have a chance to
                        interact with the artist/teacher to ask any questions,
                        clarify any doubts, submit the assignments and receive
                        feedback directly from the teachers. You also receive a
                        certificate signed by the artist/teacher.
                      </p>
                      <ul>
                        <li>Lifetime access to the course material</li>
                        <li>Do at your own pace</li>
                        <li>Submit assignments</li>
                        <li>Get feedback and reviews from {teacherName}</li>
                        <li>
                          Attend live Q&A session with {teacherName}, upto one
                          year.
                        </li>
                        <li>Receive a certificate on completion</li>
                      </ul>
                      <span
                        onClick={() => {
                          setshowmore1(false)
                        }}
                      >
                        Show less
                      </span>
                    </>
                  )}
                </div>
                <Button
                  theme='primary'
                  dis
                  onClick={async (e) => {
                    e.stopPropagation()
                    setLoading(true)
                    await registerCertification()
                    setLoading(false)
                  }}
                  disabled={loading}
                >
                  Buy Certification
                </Button>
              </div>
              <div
                style={{ backgroundColor: 'white' }}
                className='PaymentType'
                onClick={() => {
                  setShowmore2(!showmore2)
                }}
              >
                <div className='PaymentHeading'>
                  <H4>Standard</H4>
                  <span className='fee'>
                    {isDiscounted && (
                      <S05>
                        {currencySymbol} {original}
                      </S05>
                    )}
                    <H4>
                      {type !== 'recorded' ? (
                        <span>/ class</span>
                      ) : isDiscounted ? (
                        <span>({discountPercentage} off)</span>
                      ) : null}
                      {currencySymbol} {final}
                    </H4>
                  </span>
                </div>
                <Divider
                  style={{
                    backgroundColor: 'black',
                    marginTop: '5px',
                    marginBottom: '5px',
                  }}
                />
                <div>
                  {!showmore2 ? (
                    <p>
                      Standard Course ensures{' '}
                      <span
                        onClick={() => {
                          setShowmore2(true)
                        }}
                      >
                        Show more
                      </span>
                    </p>
                  ) : (
                    <>
                      <p>
                        Standard Course ensures that you have unlimited access
                        to the course, anytime, anywhere and you do it at your
                        own pace, and self-assess.
                      </p>
                      <ul>
                        <li>Lifetime access to the course material</li>
                        <li>Do at your own pace</li>
                      </ul>{' '}
                      <span
                        onClick={() => {
                          setShowmore2(false)
                        }}
                      >
                        Show less
                      </span>
                    </>
                  )}
                </div>
                <Button
                  theme='primary'
                  onClick={async (e) => {
                    e.stopPropagation()
                    setLoading(true)
                    await register()
                    setLoading(false)
                  }}
                  disabled={loading}
                >
                  Buy Standard
                </Button>
              </div>
            </RegModal>
            <br />
          </div>
        </Box>
      </Modal>
    )
  )
}

export default RegistrationModal
